import meRepository from '@/repositories/me.repository';
import { useQuery } from '@tanstack/react-query';

const staleTime = import.meta.env.MODE !== 'test' ? 1000 * 60 * 10 : 0; // 10 minutes

export function useGetMe() {
  return useQuery({
    queryKey: ['me', 'get'],
    queryFn: meRepository.get,
    staleTime,
  });
}

export default useGetMe;
